import React,{Component} from "react";
import {Redirect,Route} from "react-router-dom"
export default class Privateroute extends Component{

    checkRoute = ()=>{
    const role = localStorage.getItem("role")
     if(role){
        return <Route 
        path={this.props.path}
        render={(props)=><this.props.component {...props} />}
        />
    }
    else return  <Redirect to="/" />
    }
    render(){
        return(
            this.checkRoute()
        )
    }
}
export const Publicroute = (props)=>(
    localStorage.getItem("role") ? 
    <Redirect to="/" />:
    <Route 
        path={props.path}
        render={(props2)=><props.component {...props2} />}
        />
)